var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"desc",staticClass:"need-text",class:_vm.is_show?'show':'hide'},[_c('div',{ref:"text"},[_vm._v(_vm._s(_vm.text))])]),_vm._v(" "),(_vm.has_more)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.showMore}},[_vm._v("\n    "+_vm._s(_vm.btn_text)+"\n    "),_c('i',{staticClass:"el-icon--right",class:_vm.btn_icon})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc38052","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/pages/bizInfo/component/TextBox.vue
// module id = 865
// module chunks = 2